import * as React from "react";
const SvgDotsVertical = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.0003 10.0003H10.0087M10.0003 5.00033H10.0087M10.0003 15.0003H10.0087M10.8337 10.0003C10.8337 10.4606 10.4606 10.8337 10.0003 10.8337C9.54009 10.8337 9.16699 10.4606 9.16699 10.0003C9.16699 9.54009 9.54009 9.16699 10.0003 9.16699C10.4606 9.16699 10.8337 9.54009 10.8337 10.0003ZM10.8337 15.0003C10.8337 15.4606 10.4606 15.8337 10.0003 15.8337C9.54009 15.8337 9.16699 15.4606 9.16699 15.0003C9.16699 14.5401 9.54009 14.167 10.0003 14.167C10.4606 14.167 10.8337 14.5401 10.8337 15.0003ZM10.8337 5.00033C10.8337 5.46056 10.4606 5.83366 10.0003 5.83366C9.54009 5.83366 9.16699 5.46056 9.16699 5.00033C9.16699 4.54009 9.54009 4.16699 10.0003 4.16699C10.4606 4.16699 10.8337 4.54009 10.8337 5.00033Z",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgDotsVertical;
